export const linkoutConfigs = {
  faqs: 'https://support.viome.com/',
  contact: 'https://support.viome.com/',
  share: 'mailto:mystory@viome.com',
  terms: 'https://www.viome.com/terms',
  privacy: 'https://www.viome.com/privacy-policy',
  copyright: 'https://www.viome.com/copyright-acknowledgments',
  multipleKit:
    'https://support.viome.com/en_us/multiple-kit-troubleshooting-rkhAznejY',
};
